import React from 'react';
import { Map, List } from 'immutable';
import { formatNumber } from '../elements/BaseElement';
import { getTotalBL } from '../elements/TransportElement';
import { Button } from 'react-bootstrap';
import FancyInput from '@/component/form/numinput/index.jsx';
import { calcTransportBLCountByAllLinks } from '../expenses/ExpensesUtils';
import AlertPopover from '@/util/AlertPopover.jsx';

export default class AbstractTransportEdit extends React.Component {
  constructor(props) {
    super(props);
    this.onFreightChange = this.onFreightChange.bind(this);
    this.onChangeFreightCurrency = this.onChangeFreightCurrency.bind(this);
    this.onContractNumberChange = this.onContractNumberChange.bind(this);
  }

  onChangeFreightCurrency(val) {
    if (val) {
      this.props.updateDealFields(
        new Map({ freightCurrency: val.currency, freightCurrencyRates: val.rates }));
    }
  }

  onFreightChange(e, val) {
    if (this.props.data.get('isFreightLS')) {
      const totalBL = calcTransportBLCountByAllLinks(this.props.data);
      this.props.updateDealField('freightLSAmount', val);
      this.props.updateDealField('freightAmount', totalBL ? val / totalBL : undefined);
    } else {
      this.props.updateDealField('freightAmount', val);
    }
  }
  onFreightPTLSChange = () => {
    if (this.props.data.get('isFreightLS')) {
      this.props.updateDealField('isFreightLS', false);
      this.props.updateDealField('freightLSAmount', undefined);
      this.props.updateDealField('freightAmount', this.props.data.get('freightLSAmount'));
    } else {
      const oldVal = this.props.data.get('freightAmount');
      this.props.updateDealField('isFreightLS', true);
      this.props.updateDealField('freightLSAmount', oldVal);
      const totalBL = calcTransportBLCountByAllLinks(this.props.data);
      this.props.updateDealField('freightAmount', totalBL ? oldVal / totalBL : 'N/A');
    }
  }

  onContractNumberChange(e) {
    this.props.updateDealField('vesselName',
      e && e.target && e.target.value ? e.target.value : '');
  }

  freightInput = () => {
    let ptFreight;
    if (this.props.data.get('isFreightLS')
      && this.props.data.get('freightLSAmount') !== undefined) {
      const totalBL = calcTransportBLCountByAllLinks(this.props.data) || 1;
      if (totalBL) {
        ptFreight = this.props.data.get('freightLSAmount', 0) / totalBL;
      }
    }
    console.log(ptFreight);
    return (<span><div id={'freightAmountContainer'} className={'freightAmountContainer'}>
      <Button
        id="summtypePTLS"
        bsStyle="primary"
        style={{ width: '100%', maxWidth: '36px', height: '36px', padding: '0px' }}
        onClick={this.onFreightPTLSChange}
        disabled={this.props.disabled}
      >
        {this.props.data.get('isFreightLS') ? 'LS' : 'PT'}
      </Button>
      <FancyInput
        className="form-control"
        thousand
        fraction={2}
        positive
        negative={false}
        nullAsDefault
        type="number"
        id="freightAmount" name="freightAmount"
        value={this.props.data.get(
          this.props.data.get('isFreightLS') ? 'freightLSAmount' : 'freightAmount')}
        disabled={this.props.disabled}
        onChange={this.onFreightChange}
      />
      {this.props.data.get('isFreightLS') && !!calcTransportBLCountByAllLinks(this.props.data) &&
        <input
          disabled
          className={'freight-pt-amount'}
          value={ptFreight ? ptFreight.toFixed(2) : 'N/A'}
      />}
    </div>
    {!this.props.data.get('isFreightLS') && this.props.data.get('freightAmount') > 100 &&
      <AlertPopover
        data={`You have entered ${formatNumber(
          this.props.data.get('freightAmount'), '0,0.[000]')} for freight.
                Make sure this amount is PER TON freight and not lump sum`}
        target={'freightAmountContainer'}
        placement="bottom"
        show={this.props.data.get('freightAmount') > 100}
      />
    }
    </span>);
  }

  groupSuppliers(deals = new List()) {
    const dealsList = [];
    deals.forEach(deal => {
      const name = deal.get('supplierName', '');
      const qty = deal.get('billLandingQuantity', 0);
      const foundElement = dealsList.findIndex(i => i.name === name);

      if (foundElement > -1) {
        dealsList[foundElement] = {
          name,
          qty: dealsList[foundElement].qty += qty,
        };
      } else if (name !== null) {
        dealsList.push({
          name,
          qty,
        });
      }
    });

    return dealsList;
  }

  renderBLInfo() {
    const bLs = this.groupSuppliers(this.props.data.get('links'));
    const total = getTotalBL(this.props.data);
    return (
      <div className="bLs__total">
        <strong className="text-primary inline asParam">Total BL </strong>
        <span className="bLs__total-value">{formatNumber(total, '0,0.[000]')}</span>
        {bLs.map(i => (
          <span key={i.name}>
            {' '}<span className="bLs__total-value">/ </span>
            <strong className="text-primary inline asParam">{i.name} </strong>{' '}
            {' '}
            <span className="bLs__total-value">
              {formatNumber(i.qty, '0,0.[000]')}
            </span>
          </span>
        ))}
      </div>
    );
  }
}
AbstractTransportEdit.propTypes = {
  updateDealField: React.PropTypes.func.isRequired,
  updateDealFields: React.PropTypes.func.isRequired,
  data: React.PropTypes.object.isRequired,
  disabled: React.PropTypes.bool,
};
